import sanitizeHtml from 'sanitize-html';

export const DEFAULT_SANITIZE_OPTIONS = {
  parseStyleAttributes: false,
  allowedTags: [
    'b',
    'em',
    'strong',
    'a',
    'li',
    'ul',
    'ol',
    'p',
    'br',
    'table',
    'tr',
    'td',
    'tbody',
    'span',
  ],
  allowedAttributes: {
    a: ['href', 'target', 'rel'],
    li: [],
    ul: ['class'],
    table: ['style', 'border', 'class'],
    td: ['colspan', 'rowspan', 'style'],
    span: ['data-href', 'data-rel'],
  },
  selfClosing: ['br'],
  transformTags: {
    ul: () => ({
      tagName: 'ul',
      attribs: {
        class: 'list-basic-disc',
      },
    }),
    // br: () => ({ //why would we want <br /> to become empty <p>'s ?
    //   tagName: 'p',
    // }),
    table: (tagName, attribs) => ({
      tagName: 'table',
      attribs: {
        class: 'table table-striped',
        style: attribs.style ? `${attribs.style}; height:auto !important;` : null,
        border: attribs.border ? attribs.border : '0',
      },
    }),
    a: sanitizeHtml.simpleTransform('a', { target: '_blank' }, true),
  },
};
const FILTER_HTML_SANITIZE_OPTIONS = {
  parseStyleAttributes: false,
  allowedTags: ['br', 'ul', 'ol', 'li', 'b'],
};
const ALLOWED_ATTRIBUTES = {
  dataRel: 'data-rel',
  dataHref: 'data-href',
  href: 'href',
  rel: 'rel',
};
export const PATTERNS = {
  TERM: '(<a href="/content/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}"[^>]*rel="term"(?:(?!<\\/?a).)*>(?:(?!</?a).)*</a>)',
  MARKED_TEXT:
    '(<span data-href="/content/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}"(?:(?!<\\/?span).)*>(?:(?!</?span).)*</span>)',
  TERM_REMOVED:
    '<a href="/content/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}"[^>]*rel="term"(?:(?!<\\/?a).)*>((?:(?!</?a).)*)</a>',
  MARKED_TEXT_REMOVED:
    '<span data-href="/content/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}"(?:(?!<\\/?span).)*>((?:(?!</?span).)*)</span>',
};

const removeTag = (html, pattern) => {
  return html.replace(new RegExp(pattern, 'gi'), '$1');
};

/**
 *
 * @param  {string} html - HTML element string
 * @returns {object} key - value for all attributes of the HTML tag
 */
export const getTagAttributes = (html = '') => {
  const props = {};

  Object.keys(ALLOWED_ATTRIBUTES).forEach((key) => {
    const attributesRegexp = new RegExp(
      ` ${ALLOWED_ATTRIBUTES[key]}=["']?((?:.(?!["']?s+(?:S+)=|s*/?[>"']))+.)["']?`,
      'ig'
    );
    const [match] = [...html.matchAll(attributesRegexp)];
    if (match) {
      const [, value] = match;
      if (value) props[key] ??= value?.replace('/content/', '');
    }
  });

  return props;
};

/**
 *
 * @param  {string} html - HTML element string
 * @returns {string} Inner tag text
 */
export const getTagText = (html = '') => {
  const template = document.createElement('div');
  template.innerHTML = html;

  return template.firstChild?.innerHTML;
};

/**
 *
 * @param  {string} html - HTML tag string to get properties and text
 * @returns {Object} Object containing rel and href properties and text
 */
export const getTagProps = (html) => {
  const props = getTagAttributes(html);
  const text = getTagText(html);

  return { ...props, text };
};

/**
 *
 * @param  {string} string - HTML string to be sanitized
 * @param {Object} options - Optional sanitize options
 * @param {boolean} options.filterHTML - Remove all HTML tags
 * @param {boolean} options.compileTerm - Compile Terms
 * @param {boolean} options.compileMarkedText - Compile Marked Text
 * @param {Object} options.sanitizeConfig - Sanitize-html configuration
 * @returns {string[]} Array of sanitized strings
 */
export const sanitize = (
  string,
  { filterHTML, compileTerm, compileMarkedText, sanitizeConfig = DEFAULT_SANITIZE_OPTIONS } = {}
) => {
  if (filterHTML) return [sanitizeHtml(string, FILTER_HTML_SANITIZE_OPTIONS)];

  let sanitizedString = sanitizeHtml(string, sanitizeConfig);
  const patterns = [];

  if (compileMarkedText) patterns.push(PATTERNS.MARKED_TEXT);
  else sanitizedString = removeTag(sanitizedString, PATTERNS.MARKED_TEXT_REMOVED);

  if (compileTerm) patterns.push(PATTERNS.TERM);
  else sanitizedString = removeTag(sanitizedString, PATTERNS.TERM_REMOVED);

  if (patterns.length) {
    const result = sanitizedString
      .split(new RegExp(`${patterns.join('|')}`, 'gi'))
      .filter((e) => e);

    return result;
  }
  return [sanitizedString];
};

export default sanitize;
